import {
  FormControl,
  InputGroup,
  InputGroupProps,
  InputRightElement,
  FormErrorMessage,
  Flex,
  Text,
  FormControlProps,
  FormLabel,
} from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';
import { Profit } from '../article/variant/sales/shared';

export interface TexasInputWrapperProps {
  label?: string;
  bottomLabel?: string;
  children: React.ReactNode;
  utilButtons?: React.ReactNode;
  rightAddon?: string;
  error?: FieldError;
  profit?: Profit;
  formControlProps?: FormControlProps;
  inputGroupProps?: InputGroupProps;
}

export function TexasInputWrapper(props: TexasInputWrapperProps) {
  return (
    <FormControl
      {...props.formControlProps}
      isInvalid={props.error !== undefined}
      alignItems="start"
      width="100%"
    >
      {props.label && (
        <FormLabel m={0} pl={1}>
          {props.label}
        </FormLabel>
      )}

      <InputGroup padding={1} role="group" {...props.inputGroupProps}>
        {props.children}

        {(props.utilButtons || props.rightAddon) && (
          <InputRightElement
            width="auto"
            right={4}
            top="50%"
            transform="translateY(-50%)"
          >
            <Flex gap={1}>
              {props.rightAddon && (
                <Text fontSize="xs" opacity={0.7}>
                  {props.rightAddon}
                </Text>
              )}
              {props.utilButtons && <>{props.utilButtons}</>}
            </Flex>
          </InputRightElement>
        )}
      </InputGroup>
      <FormErrorMessage fontSize={12}>{props.error?.message}</FormErrorMessage>
      <Flex>
        {props.bottomLabel && (
          <Text fontSize="xs" opacity={0.7} pl={1}>
            {props.bottomLabel}
          </Text>
        )}
      </Flex>
    </FormControl>
  );
}
